export default __webpack_public_path__ + "static/media/eIcon3.97f643c3.svg";